import _to from './to';
import _from from './from';
import type { Types } from './types';

export class Map {
  static from = _from;
  static to   = _to;
}

export { Types };